'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Mittelgeber = require('../entity').Mittelgeber;

module.exports = function (connection) {
  return {
    byFinSchluesselEquals: function byFinSchluesselEquals(finschluessel, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byFinSchluesselEquals', 'finschluessel')(finschluessel, additionalParams);
    },
    byFinSchluesselLike: function byFinSchluesselLike(finschluessel, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byFinSchluesselLike', 'finschluessel')(finschluessel, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byUeberMittelgeberEquals: function byUeberMittelgeberEquals(uebermittelgeber, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byUeberMittelgeberEquals', 'uebermittelgeber')(uebermittelgeber, additionalParams);
    },
    byUeberMittelgeberIsNull: function byUeberMittelgeberIsNull(page, additionalParams) {
      return templates.searchTemplate(connection)(Mittelgeber, 'byUeberMittelgeberIsNull', 'page')(page, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Mittelgeber, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('mittelgeber')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/mittelgeber.js
// module id = J2hL
// module chunks = 0